<ng-container *ngIf="data$ | async as valioVideo">
  <ng-container *ngIf="valioVideo.youtubeId">
    <youtube-player videoId="{{valioVideo.youtubeId}}"></youtube-player>
  </ng-container>
</ng-container>
